import { Tariff } from '../types';
import { TARIFF_UNITS } from './balanceFormatter';

/**
 * Transform a backend tariff object (tariffElements[].priceComponents[]) into
 * the flat display list used by both the live charging page and the post-charge
 * summary. Returns an empty array when no tariff/components are present.
 */
export function mapTariffToDisplay(tariff: any): Tariff[] {
  if (!tariff || !tariff.tariffElements) return [];

  const tariffs: Tariff[] = [];

  for (const element of tariff.tariffElements) {
    if (!element.priceComponents) continue;

    for (const component of element.priceComponents) {
      let name = component.type;
      let unit = TARIFF_UNITS.default;

      switch (component.type) {
        case 'Energy':
          name = 'Energy Rate';
          unit = TARIFF_UNITS.Energy;
          break;
        case 'Time':
          name = 'Time Rate';
          unit = TARIFF_UNITS.Time;
          break;
        case 'Flat':
          name = 'Session Fee';
          unit = TARIFF_UNITS.Flat;
          break;
        case 'ParkingTime':
          name = 'Parking Fee';
          unit = TARIFF_UNITS.ParkingTime;
          break;
      }

      tariffs.push({
        name,
        rate: component.price,
        unit,
      });
    }
  }

  return tariffs;
}
